// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `rails generate channel` command.
// @ts-ignore
import { createConsumer } from "@rails/actioncable"

export default createConsumer(window.APP_CONFIG.BASE_URL_WSS)
